module.exports = __webpack_public_path__ + "img/circleVtb.4ee9b5cd.svg";